import autoAnimate, { AutoAnimateOptions, AutoAnimationPlugin } from '@formkit/auto-animate';

import { modifier } from 'ember-modifier';

export default modifier(
  (
    el: HTMLElement,
    [enabled = true]: [boolean],
    options: Partial<AutoAnimateOptions> | AutoAnimationPlugin
  ) => {
    if (enabled) {
      autoAnimate(el, options || {});
    }

    return () => {};
  },
  { eager: false }
);
